import React from "react";
import { Link } from "react-router-dom";
import PageLayout from "../../components/Clearith/PageLayout";

const ErrorPage: React.FC = () => (
  <PageLayout title="Page introuvable" breadcrumb="Erreur 404">
    <section className="cl-page-section">
      <div className="container">
        <div className="cl-error-content">
          <span>404</span>
          <h2>Cette page n’existe pas ou a été déplacée.</h2>
          <p>
            Revenez à l’accueil ou consultez le catalogue des formations
            CLEARITH.
          </p>
          <div>
            <Link className="thm-btn agency-btn" to="/">
              <span className="text">Retour à l’accueil</span>
            </Link>
            <Link className="cl-outline-btn" to="/formations">
              Voir les formations
            </Link>
          </div>
        </div>
      </div>
    </section>
  </PageLayout>
);

export default ErrorPage;
